export default "__VITE_ASSET__0fad22c5__"